import {i18n} from '@/plugins/i18n'

export const walletOpenBankingRequestStatus = {
    SUCCESS: 1,
    FAILED: 2,
};
export const walletOpenBankingRequestProvider = {
    ShahinKeshavarzi: 1,
    ShahinSaderat: 2,
    Saman: 3,
    Mellat: 4,
    FaraboomMelli: 5,
    FinnotechAyande: 6,
    Sanbod: 7,
    SunySaderat: 8,
};

export const walletOpenBankingRequestStatusStr = {
    SUCCESS: i18n.t('label.success'),
    FAILED: i18n.t('label.failed'),

    get(status) {
        let status_str = null;

        Object.keys(walletOpenBankingRequestStatus).forEach(item => {
            if (walletOpenBankingRequestStatus[item] === status) {
                status_str = walletOpenBankingRequestStatusStr[item];
            }
        });

        return status_str;
    }
};
export const walletOpenBankingRequestProviderStr = {
    ShahinKeshavarzi: i18n.t('wallet_open_banking.providers.shahin_keshavarzi'),
    ShahinSaderat: i18n.t('wallet_open_banking.providers.shahin_saderat'),
    Saman: i18n.t('wallet_open_banking.providers.saman'),
    Mellat: i18n.t('wallet_open_banking.providers.mellat'),
    FaraboomMelli: i18n.t('wallet_open_banking.providers.farabom_melli'),
    FinnotechAyande: i18n.t('wallet_open_banking.providers.finnotech_ayande'),
    Sanbod: i18n.t('wallet_open_banking.providers.sanbod'),
    SunySaderat: i18n.t('wallet_open_banking.providers.suny_saderat'),

    get(provider) {
        let provider_str = null;

        Object.keys(walletOpenBankingRequestProvider).forEach(item => {
            if (walletOpenBankingRequestProvider[item] === provider) {
                provider_str = walletOpenBankingRequestProviderStr[item];
            }
        });

        return provider_str;
    }
};

export const walletOpenBankingRequestStatusVariant = (status) => {
    switch (status) {
        case walletOpenBankingRequestStatus.SUCCESS:
            return 'success';
        case walletOpenBankingRequestStatus.FAILED:
            return 'danger';
    }

    return 'primary';
};
